
// import { Layout } from 'antd';
import React, { useState, useEffect } from 'react';
import { Layout, Modal } from 'antd';
import { Button, Space, Form, Input } from 'antd';
import LoginService from '../../services/LoginService';
const { Header, Content, Footer } = Layout;



export default function ForgotPassword() {
    const version = `${process.env.REACT_APP_VERSION}`;
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [buttonLabel, setButtonLabel] = useState("Send");
    const [position, setPosition] = useState("start")
    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      };

      const onFinish = (values) => {
        setLoading(true)
        setButtonLabel("Sending")
      LoginService.forgotPassword(values.email).then((response) => {
        moduleNotAvailable();
        setLoading(false)
        setButtonLabel("Send")
        //  setResponse(response.data)
        }).catch((e) => {
            var ex = e;
            setLoading(false)
            setButtonLabel("Send")
            // setResponse("")
        })        
   
      };

   const moduleNotAvailable = () => {
      Modal.info({
         // icon: <AntDIcons.InfoCircleTwoTone twoToneColor='#369DA2' />,
         title: 'Brainee LMS',
         content: 'The password has been emailed to you.',
         centered: true,
      });
   }    
   return (
      <>
         <Layout className="layout" style={{ backgroundColor: "white", height: "100vh" }}>
            <Header style={{ height: "70px", backgroundColor: "white", borderBottom: "5px", borderBottomColor: "black", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}>
               <div className="header-logo" >
                  <img src="/images/brainee_logo_new.png" height="52px"></img>
               </div>
            </Header>
            <Content style={{ minHeight: "480px", overflow: "auto", justifyContent: "center", alignItems: "center", display: "flex" }}>
            <div class="container" >
                <div class="d-flex justify-content-center">
                    <div class="col-md-7">
                        <div class="card rounded-0 shadow">
                            <div class="card-body">
                                <h3>Forgot Password</h3>
                                <Form
                                        {...layout}
                                        form={form}
                                        name="control-hooks"
                                        onFinish={onFinish}
                                        style={{ maxWidth: 600 }}
                                        >
                                    <div class="form-group">
                                        {/* <label for="exampleInputEmail1">Email address:</label> */}
                                        <Form.Item
                                            label="Email address:"
                                            labelAlign="left"
                                            labelCol={{
                                                span: 5
                                              }}
                                            name="email"
                                            rules={[{ required: true, message: 'Please input your email!' }]}
                                            >
                                            <Input />
                                        </Form.Item>
                                        <small id="email" class="form-text text-muted">We'll send your password on your email.</small>
                                    </div>
                                    <Space>
                                    <Button type="primary" htmlType="submit" loading={loading}  iconPosition="emd">
                                        {buttonLabel}
                                    </Button>
                                    <Button htmlType="button" onClick={() =>  window.location.href = '/'} >
                                        Cancel
                                    </Button>  
                                    </Space>   
                                </Form>                                   
                            </div>
                        </div>
                    </div>
                </div>    
            </div>                 
            </Content>
            <Footer style={{ textAlign: 'center', backgroundColor: "white", height: "70px", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)" }}>Brainee ©2022 Powered by Campus Cloud IT Consultancy - Ver.{version}</Footer>
        </Layout>   
      </>
   )
}
